/*
 * @Autor: haoyi
 * @LastEditors: haoyi
 * @LastEditTime: 2021-11-08 18:16:01
 * @Description:
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/Home.vue'
import cityHome from '../pages/cityHome.vue'
import cityBox from '../components/BrandMenu.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/cityHome',
    name: 'cityHome',
    component: cityHome
  },
  {
    path: '/cityBox',
    name: 'cityBox',
    component: cityBox
  }
]

// const router = new VueRouter({
//   routes
// })

const router = new VueRouter({
  routes,

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
